import * as Types from '../../.cache/__types__/index';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type IntercomUserTokenQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type IntercomUserTokenQuery = { __typename?: 'Query', intercomUserToken: string };


export const IntercomUserTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"intercomUserToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"intercomUserToken"}}]}}]} as unknown as DocumentNode<IntercomUserTokenQuery, IntercomUserTokenQueryVariables>;